import { HttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { ProductsWithoutStockModel, ProductsWithoutStockSummary } from '../models/ProductsWithoutStock';

export interface ProductsWithoutStockFilters {
  searchTerm?: string;
  team_id?: number;
  shop_id?: number;
  payment_method_id?: number;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
}

export interface ProductsWithoutStockPage {
  productsWithoutStock: ProductsWithoutStockModel[];
  summary: ProductsWithoutStockSummary;
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class ProductsWithoutStockApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getProductsWithoutStockPaginated(filters: ProductsWithoutStockFilters = {}): Promise<ProductsWithoutStockPage> {
    const {
      searchTerm = '',
      team_id,
      shop_id,
      payment_method_id,
      sortBy = 'product_id',
      sortDirection = 'desc',
      page = 1,
      limit = 15,
    } = filters;

    const params: any = {
      ...(searchTerm && { search: searchTerm }),
      ...(team_id && { team_id }),
      ...(shop_id && { shop_id }),
      ...(payment_method_id && { payment_method_id }),
      ...(sortBy && { order_by: sortBy }),
      ...(sortDirection && { order_direction: sortDirection }),
      page,
      per_page: limit,
    };

    const response = await this.httpClient.get<any>('/report/product-without-stock', params);

    return {
      productsWithoutStock: response.data.products,
      summary: response.data.summary,
      nextPage: undefined,
      hasMore: false,
      total: response.data.summary.total_products,
    };
  }

  async getAll(): Promise<ProductsWithoutStockModel[]> {
    const response = await this.getProductsWithoutStockPaginated();
    return response.productsWithoutStock;
  }

  async downloadExcel(filters: ProductsWithoutStockFilters = {}): Promise<{
    blob: Blob;
    filename: string;
  }> {
    const {
      searchTerm = '',
      team_id,
      shop_id,
      payment_method_id,
      sortBy = 'product_id',
      sortDirection = 'desc',
    } = filters;

    const params: any = {
      ...(searchTerm && { search: searchTerm }),
      ...(team_id && { team_id }),
      ...(shop_id && { shop_id }),
      ...(payment_method_id && { payment_method_id }),
      ...(sortBy && { order_by: sortBy }),
      ...(sortDirection && { order_direction: sortDirection }),
    };

    const response = await apiClientWH.get<Blob>('/report/excel/product-without-stock', {
      params,
      responseType: 'blob',
    });

    const contentDisposition = response.headers['content-disposition'] || '';
    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
    const filename = filenameMatch ? filenameMatch[1].replace(/['"]/g, '') : 'productos_sin_stock.xlsx';

    return { blob: response.data, filename };
  }
}
